/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, makeObservable, } from 'mobx';
//https://casesandberg.github.io/react-color/
import { CirclePicker } from 'react-color';

import { type NoteInfo } from '@root/models/NoteInfo';
import { PromiseCompletion } from '@classes/PromiseCompletion';
import { type IModalDialogContent, type ModalButtonOptions, ModalButtonType, type ModalDialogOptions, ModalWindow } from '@components/Modal';

export type ColorNoteDialogProps = {
  note: NoteInfo;
};

@observer
export default class ColorNoteDialog extends React.Component<ColorNoteDialogProps> implements IModalDialogContent<string> {
  @observable private _color: string;
  private _loader: PromiseCompletion = new PromiseCompletion();

  constructor(props: ColorNoteDialogProps){
    super(props);
    makeObservable(this);
    const { note } = this.props;
    
    this._color = note.color;
  }

  public getModalOptions(window: ModalWindow<string>): ModalDialogOptions<string> {
    const buttons: ModalButtonOptions<string>[] = [];
    
    buttons.push({
      type: ModalButtonType.Cancel,
      onClick: () => {
        window.close();
      }
    });
    buttons.push({
      title: 'Choose color',
      type: ModalButtonType.Save,
      onClick: async () => {
        await this._onSaveClick(window);
        window.close(ModalButtonType.Save);
      }
    });

    return {
      title: `Choose color`,
      width: 300,
      buttons: buttons,
      loader: this._loader
    };
  }

  render(){
    return (
      <>
        <div className="form-group">
          <label className="form-group-label">Color</label>
          <CirclePicker color={this._color} onChange={(e) => this._color = e.hex}/>
        </div>
      </>
    );
  }
  
  @action.bound
  private async _onSaveClick(window: ModalWindow<string>){
    window.close(ModalButtonType.Ok, this._color);
  }
}